import { lazy } from "react";
import { BookOpen } from "lucide-react";

import type { TenantModule } from "../../domain/tenantModule";

/**
 * A NO-OP module that exists to PROVE the seam. No tenant enables it, so if "Reference"
 * ever appears in a navigation, or "Nodes" ever replaces "Sites", the seam is broken.
 */
export const reference: TenantModule = {
  key: "_reference",
  name: "Reference (never enabled)",
  navigation: {
    "reference-home": {
      label: "Reference",
      icon: BookOpen,
      path: "/_reference",
      permission: "none",
      group: "admin",
    },
  },
  routes: [
    {
      path: "/_reference",
      title: "Reference",
      desktop: lazy(() => import("./pages/desktop/ReferenceHome")),
      permission: "none",
      module: "_reference",
    },
  ],
  labels: {
    site: "Node",
    sites: "Nodes",
  },
};

export default reference;
